module.exports = __webpack_public_path__ + "img/bsc.4580d35d.svg";